import { render, staticRenderFns } from "./learningAdd.vue?vue&type=template&id=ae38a08e&scoped=true&"
import script from "./learningAdd.vue?vue&type=script&lang=js&"
export * from "./learningAdd.vue?vue&type=script&lang=js&"
import style0 from "./learningAdd.vue?vue&type=style&index=0&id=ae38a08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae38a08e",
  null
  
)

export default component.exports